import React from 'react'
import './footer.css'
const Footer = () => {
  return (
    <p className="copy-right">✨This Websit Design and Devolope By Hind hisham @ 2022</p>
  )
}

export default Footer